import Component from "@ember/component"
import { inject as service } from "@ember/service"
import type { Course } from "@shared/models/course"
import type { Planbook } from "@shared/models/planbook"
import type { RotationCalendar } from "@shared/models/rotation-calendar"
import type EmberStore from "cc-frontend/services/ember-store"
import type ModalManager from "cc-frontend/services/modal-manager"

/** One side of the comparison: a course, and the planbook and calendar it is planned on. */
interface CourseModels {
  planbook: Planbook
  course: Course
  rotationCalendar: RotationCalendar
  /** Opens that course's settings. Left off a side whose course must not be edited from here. */
  editCourseTitleAndOrder?: (courseId: string) => void
}

interface ModelArg {
  /**
   * The unit's own course.
   * It is not always the course whose lesson is on the right.
   */
  unit: CourseModels & { unitId: string }
  /** The lesson's course and date. */
  lesson: CourseModels & { dateString: string }
  showUnitReadonly?: boolean
}

export default class UnitComparisonModalComponent extends Component {
  // Args
  model!: ModelArg

  // State
  isOpen: boolean = false
  animateInClass: string = "zoomInDown"
  animateOutClass: string = "zoomOutUp"

  // Services
  @service("ember-store") store!: EmberStore
  @service modalManager!: ModalManager
}
